module.exports = __webpack_public_path__ + "static/media/section-distribution.530fc57b.svg";